import { http } from '@/services/http_service';
export default {
    getPointLogs(context, data)
    {
        return http()
        .post("/point/logs?page="+data.page, data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            console.log("넘겨받은 데이터 확인",data); 

            context.commit('setPointLogs', response.data)   

            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },   
    
    getRewardLogs(context, data)
    {
        return http()
        .post("/point/rewardLogs", data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            console.log("넘겨받은 데이터 확인",data); 

            context.commit('setRewardLogs', response.data.logs)   
            context.commit('setRewardTotal', response.data.total)   
            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },  
}